import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const FriendFindingSection = () => {
  const handleTestClick = () => {
    window.open('https://t.me/Aidating_love7_bot?start=007_res', '_blank');
  };

  const friendFindingBenefits = [
    {
      id: 'relocation',
      icon: 'Globe',
      title: 'Переезд в новую страну',
      description: 'Цифровой двойник найдёт вам друзей в новом месте на основе 7 каналов коммуникации.'
    },
    {
      id: 'common-interests',
      icon: 'Users',
      title: 'Единомышленники',
      description: 'Алгоритм анализирует тысячи профилей и доставляет вам готовые совпадения для дружбы.'
    },
    {
      id: 'personality-match',
      icon: 'Heart',
      title: 'Совместимость по 7 каналам',
      description: 'Тест определяет, как вы общаетесь: визуал, аудио, кинестетика, логика, эмпатия, вкус, запах.'
    }
  ];

  return (
    <section id="friend-finding" className="py-20 sm:py-32 bg-gradient-to-br from-accent/5 to-background">
      <div className="max-w-content mx-auto px-4 sm:px-6">
        <div className="max-w-4xl mx-auto">
          <div className="text-center mb-16">
            <div className="inline-flex items-center gap-2 px-4 py-2 bg-accent/10 rounded-full text-accent text-sm font-medium mb-6">
              <Icon name="Users" size={16} />
              <span>Больше чем знакомства</span>
            </div>

            <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-foreground mb-6">
              Цифровой двойник для поиска друзей
            </h2>

            <p className="text-lg text-secondary">
              Первый шаг — пройти тест на 7 каналов коммуникации. Цифровой двойник найдёт вам друзей, а не только партнёров.
            </p>
          </div>

          <div className="grid md:grid-cols-3 gap-6 mb-12">
            {friendFindingBenefits.map((benefit) => (
              <div
                key={benefit.id}
                className="bg-card rounded-xl p-6 border border-border hover:border-accent transition-all duration-300"
              >
                <div className="w-12 h-12 bg-accent/10 rounded-full flex items-center justify-center mb-4">
                  <Icon name={benefit.icon as any} size={24} color="var(--color-accent)" />
                </div>
                <h3 className="text-lg font-semibold text-foreground mb-2">
                  {benefit.title}
                </h3>
                <p className="text-secondary text-sm leading-relaxed">
                  {benefit.description}
                </p>
              </div>
            ))}
          </div>

          <div className="bg-card rounded-2xl p-8 border border-border">
            <div className="flex flex-col md:flex-row items-center gap-6">
              <div className="w-16 h-16 bg-accent/10 rounded-full flex items-center justify-center flex-shrink-0">
                <Icon name="MessageSquare" size={32} color="var(--color-accent)" />
              </div>
              <div className="flex-1 text-center md:text-left">
                <h3 className="text-xl font-semibold text-foreground mb-2">
                  Как это работает для поиска друзей?
                </h3>
                <p className="text-secondary">
                  Вы проходите тест на 7 каналов коммуникации. 
                  Цифровой двойник автоматически ищет совместимых людей для дружбы, 
                  не учитывая внешность и сексуальные предпочтения.
                </p>
              </div>
              <Button
                size="lg"
                variant="secondary"
                iconName="Brain"
                iconPosition="left"
                onClick={handleTestClick}
                className="flex-shrink-0"
              >
                Пройти тест
              </Button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FriendFindingSection;